import React, { useState, useEffect } from 'react';
import { TrendingUp, Users, Package, Star, ArrowRight, Play, Truck, Shield, Clock } from 'lucide-react';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    // set initial value
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = [
    {
      title: "Palettes d'Hygiène Professionnelle",
      subtitle: "Produits de grandes marques à prix déstockage — idéales pour revendeurs et professionnels",
      image: "/WhatsApp Image 2025-10-22 à 15.59.01_22f6965d.jpg",
      cta: "Voir nos offres"
    },
    {
      title: "Stock Disponible en Grandes Quantités",
      subtitle: "Réapprovisionnement régulier et livraison express pour votre activité",
      image: "/20170923-130026-bt2va6-c10fea.jpg",
      cta: "Parcourir le catalogue"
    },
    {
      title: "Économisez jusqu'à 70%",
      subtitle: "Achat en gros — marges optimisées pour votre commerce",
      image: "/20180928-152504-pk6zh6.jpg",
      cta: "Profiter des remises"
    },
    {
      title: "Vous ne trouverez meilleur prix nulle part ailleurs",
      subtitle: "Un engagement envers la qualité et l'accessibilité",
      image: "/WhatsApp Image 2025-10-22 à 15.59.03_772e94d6.jpg",
      cta: "Profiter des remises"
    }
  ];

  const stats = [
    { icon: Users, value: "500+", label: "Clients professionnels satisfaits" },
    { icon: Package, value: "1000+", label: "Palettes expédiées" },
    { icon: TrendingUp, value: "98%", label: "Taux de satisfaction" },
    { icon: Truck, value: "48h", label: "Délai moyen de livraison" }
  ];



  const testimonials = [
    {
      name: "Arnaud Peron",
      role: "Propriétaire de salon",
      text: "Livraison fiable et palettes conformes — mes clients sont ravis et mes marges ont augmenté.",
      rating: 5,
      avatar: "https://i.pravatar.cc/150?img=1"
    },
    {
      name: "Pierre Martin",
      role: "Gérant de supérette",
      text: "Stock parfait pour mon rayon hygiène — commandes simples et livraison dans les temps.",
      rating: 5,
      avatar: "https://i.pravatar.cc/150?img=3"
    },
    {
      name: "Sophie Laurent",
      role: "Revendeuse en ligne",
      text: "La qualité est au rendez-vous, et les remises permettent d'augmenter mes profits rapidement.",
      rating: 5,
      avatar: "https://i.pravatar.cc/150?img=5"
    }
  ];

  const videos = [
    {
      title: "Présentation : Palette Hygiène Premium",
      thumbnail: "/I1.jpg",
      videoUrl: "/V1.mp4",
    },
    {
      title: "Présentation : Palette Soins & Cosmétiques",
      thumbnail: "/I2.jpg",
      videoUrl: "/V2.mp4",
    },
    {
      title: "Présentation : Palette Entretien Professionnel",
      thumbnail: "/I3.jpg",
      videoUrl: "/V3.mp4",
    }
  ];

  const features = [
    {
      icon: Shield,
      title: "Authenticité garantie",
      description: "Tous nos produits sont contrôlés — pas de contrefaçons, uniquement des marques vérifiées"
    },
    {
      icon: Truck,
      title: "Expédition fiable",
      description: "Logistique optimisée — expédition rapide et suivi disponible"
    },
    {
      icon: Clock,
      title: "Support commercial",
      description: "Conseils pour assortir vos palettes et optimiser vos marges"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const styles = {
    container: {
      width: '100%',
      overflowX: 'hidden',
    },
    hero: {
      position: 'relative',
      height: '100vh',
      minHeight: isMobile ? '500px' : '600px',
      overflow: 'hidden',
    },
    slide: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      transition: 'opacity 1s ease-in-out',
    },
    slideImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    heroContent: {
      textAlign: 'center',
      color: '#ffffff',
      padding: isMobile ? '2rem' : '3rem',
      maxWidth: '800px',
    },
    heroTitle: {
      fontSize: isMobile ? '2rem' : '3.5rem',
      fontWeight: '800',
      marginBottom: '1rem',
      fontFamily: "'Montserrat', sans-serif",
      textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    },
    heroSubtitle: {
      fontSize: isMobile ? '1.2rem' : '1.8rem',
      marginBottom: '2rem',
      color: '#ffffff',
      textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
    },
    ctaButton: {
  background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
      color: '#000000',
      padding: isMobile ? '1rem 2rem' : '1.2rem 3rem',
      border: 'none',
      borderRadius: '50px',
      fontSize: isMobile ? '1rem' : '1.2rem',
      fontWeight: '700',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 8px 25px rgba(197, 155, 0, 0.35)',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    indicators: {
      position: 'absolute',
      bottom: '2rem',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '1rem',
      zIndex: 10,
    },
    indicator: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      border: '2px solid #ffffff',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    section: {
      padding: isMobile ? '3rem 1.5rem' : '5rem 2rem',
      maxWidth: '1400px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: isMobile ? '2rem' : '2.8rem',
      fontWeight: '800',
      textAlign: 'center',
      marginBottom: isMobile ? '1rem' : '1.5rem',
      fontFamily: "'Montserrat', sans-serif",
      color: '#000000',
    },
    sectionSubtitle: {
      fontSize: isMobile ? '1rem' : '1.2rem',
      textAlign: 'center',
      color: '#666666',
      marginBottom: isMobile ? '2rem' : '3rem',
      maxWidth: '700px',
      margin: '0 auto 3rem',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
      gap: isMobile ? '1.5rem' : '2rem',
      marginTop: '3rem',
    },
    statCard: {
      background: '#ffffff',
      padding: isMobile ? '1.5rem' : '2rem',
      borderRadius: '20px',
      textAlign: 'center',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      border: '2px solid transparent',
    },
    statIcon: {
      width: isMobile ? '50px' : '60px',
      height: isMobile ? '50px' : '60px',
  background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1rem',
      transition: 'transform 0.3s ease',
    },
    statValue: {
      fontSize: isMobile ? '2rem' : '2.5rem',
      fontWeight: '800',
      color: '#000000',
      marginBottom: '0.5rem',
    },
    statLabel: {
      fontSize: isMobile ? '0.9rem' : '1rem',
      color: '#666666',
      fontWeight: '500',
    },
    palettesGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '2rem' : '2.5rem',
    },
    paletteCard: {
      background: '#ffffff',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      border: '2px solid transparent',
    },
    paletteImage: {
      width: '100%',
      height: isMobile ? '180px' : '250px',
      objectFit: 'cover',
      transition: 'transform 0.3s ease',
    },
    paletteContent: {
      padding: isMobile ? '1.5rem' : '2rem',
    },
    paletteName: {
      fontSize: isMobile ? '1.3rem' : '1.5rem',
      fontWeight: '700',
      marginBottom: '0.5rem',
      color: '#000000',
    },
    paletteDescription: {
      color: '#666666',
      marginBottom: '1.5rem',
      fontSize: isMobile ? '0.9rem' : '1rem',
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '1.5rem',
    },
    price: {
      fontSize: isMobile ? '1.8rem' : '2rem',
      fontWeight: '800',
  color: '#c59b00',
    },
    oldPrice: {
      fontSize: isMobile ? '1.2rem' : '1.3rem',
      color: '#999999',
      textDecoration: 'line-through',
    },
    discount: {
  background: '#c59b00',
      color: '#ffffff',
      padding: '0.3rem 0.8rem',
      borderRadius: '20px',
      fontSize: '0.9rem',
      fontWeight: '700',
    },
    addToCartBtn: {
      width: '100%',
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
      color: '#ffffff',
      padding: '1rem',
      border: 'none',
      borderRadius: '12px',
      fontSize: '1rem',
      fontWeight: '700',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
    },
    videosGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '2rem' : '2.5rem',
    },
    videoCard: {
      position: 'relative',
      borderRadius: '20px',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      height: isMobile ? '180px' : '250px',
      display: 'block'
    },
    videoThumbnail: {
      width: '100%',
      height: isMobile ? '180px' : '250px',
      objectFit: 'cover',
      transition: 'transform 0.3s ease',
    },
    playButton: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '70px',
      height: '70px',
      background: '#c59b00',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s ease',
    },
    videoInfo: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: '1.5rem',
      background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)',
      color: '#ffffff',
    },
    videoTitle: {
      fontSize: isMobile ? '1rem' : '1.2rem',
      fontWeight: '700',
      marginBottom: '0.5rem',
    },
    videoDuration: {
      fontSize: '0.9rem',
      color: '#ff6b35',
      fontWeight: '600',
    },
    testimonialsGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '2rem' : '2.5rem',
    },
    testimonialCard: {
      background: '#ffffff',
      padding: isMobile ? '2rem' : '2.5rem',
      borderRadius: '20px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      transition: 'all 0.3s ease',
      border: '2px solid transparent',
    },
    testimonialHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '1.5rem',
    },
    avatar: {
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      objectFit: 'cover',
  border: '3px solid #c59b00',
    },
    testimonialInfo: {
      flex: 1,
    },
    testimonialName: {
      fontSize: '1.1rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.3rem',
    },
    testimonialRole: {
      fontSize: '0.9rem',
      color: '#666666',
    },
    stars: {
      display: 'flex',
      gap: '0.3rem',
      marginBottom: '1rem',
    },
    testimonialText: {
      fontSize: isMobile ? '0.95rem' : '1rem',
      lineHeight: '1.8',
      color: '#333333',
      fontStyle: 'italic',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
      gap: isMobile ? '2rem' : '3rem',
      marginTop: '4rem',
    },
    featureCard: {
      textAlign: 'center',
      padding: isMobile ? '2rem' : '2.5rem',
      background: '#f8f9fa',
      borderRadius: '20px',
      transition: 'all 0.3s ease',
    },
    featureIcon: {
      width: '80px',
      height: '80px',
  background: 'linear-gradient(135deg, #c59b00 0%, #ffd866 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 1.5rem',
      transition: 'transform 0.3s ease',
    },
    featureTitle: {
      fontSize: isMobile ? '1.2rem' : '1.4rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '1rem',
    },
    featureDescription: {
      fontSize: isMobile ? '0.95rem' : '1rem',
      color: '#666666',
      lineHeight: '1.6',
    },
    darkSection: {
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)',
      padding: isMobile ? '3rem 1.5rem' : '5rem 2rem',
      color: '#ffffff',
    },
  };

  const StatCard = ({ icon: Icon, value, label }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        style={{
          ...styles.statCard,
          transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
          borderColor: isHovered ? '#c59b00' : 'transparent',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          style={{
            ...styles.statIcon,
            transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0deg)',
          }}
        >
          <Icon size={isMobile ? 24 : 30} color="#000000" />
        </div>
        <div style={styles.statValue}>{value}</div>
        <div style={styles.statLabel}>{label}</div>
      </div>
    );
  };



  const VideoCard = ({ video }) => {
    const [isHovered, setIsHovered] = useState(false);
    // Open modal in parent scope
    const handlePlay = () => {
      openModalWith(video);
    };

    return (
      <div
        style={{
          ...styles.videoCard,
          transform: isHovered ? 'scale(1.05)' : 'scale(1)',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={{ position: 'relative' }} onClick={handlePlay}>
          <div style={{ position: 'relative' }} onClick={handlePlay}>
            <img
              src={video.thumbnail}
              alt={video.title}
              style={{
                ...styles.videoThumbnail,
                transform: isHovered ? 'scale(1.1)' : 'scale(1)',
                display: 'block'
              }}
            />
            <div
              style={{
                ...styles.playButton,
                transform: isHovered
                  ? 'translate(-50%, -50%) scale(1.2)'
                  : 'translate(-50%, -50%) scale(1)',
              }}
            >
              <Play size={30} color="#000000" fill="#000000" />
            </div>
          </div>
          </div>
        <div style={styles.videoInfo}>
          <div style={styles.videoTitle}>{video.title}</div>
        </div>
      </div>
    );
  };

  // Modal overlay JSX (renders when modalOpen is true)
  const ModalPlayer = () => {
    if (!modalOpen || !modalVideo) return null;
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.75)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          padding: '1.5rem'
        }}
        onClick={closeModal}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            width: '100%',
            maxWidth: '1100px',
            height: '60vh',
            background: '#000000',
            borderRadius: '10px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <video
            ref={modalVideoRef}
            src={modalVideo.videoUrl}
            style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            controls
            autoPlay
            playsInline
            preload="auto"
          />
        </div>
      </div>
    );
  };

  // Modal state for playing video in overlay
  const [modalOpen, setModalOpen] = useState(false);
  const [modalVideo, setModalVideo] = useState(null);
  const modalVideoRef = React.useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setModalOpen(false);
      }
    };
    if (modalOpen) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [modalOpen]);

  const openModalWith = (video) => {
    setModalVideo(video);
    setModalOpen(true);
    // small timeout to allow modal render then autoplay
    setTimeout(() => {
      try {
        if (modalVideoRef.current) {
          modalVideoRef.current.currentTime = 0;
          modalVideoRef.current.play().catch(() => {});
        }
      } catch (e) {}
    }, 80);
  };

  const closeModal = () => {
    try {
      if (modalVideoRef.current) {
        modalVideoRef.current.pause();
        modalVideoRef.current.currentTime = 0;
      }
    } catch (e) {}
    setModalOpen(false);
    setModalVideo(null);
  };

  const TestimonialCard = ({ testimonial }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        style={{
          ...styles.testimonialCard,
          transform: isHovered ? 'translateY(-10px)' : 'translateY(0)',
          borderColor: isHovered ? '#c59b00' : 'transparent',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={styles.testimonialHeader}>
          <img src={testimonial.avatar} alt={testimonial.name} style={styles.avatar} />
          <div style={styles.testimonialInfo}>
            <div style={styles.testimonialName}>{testimonial.name}</div>
            <div style={styles.testimonialRole}>{testimonial.role}</div>
          </div>
        </div>
        <div style={styles.stars}>
          {[...Array(testimonial.rating)].map((_, i) => (
            <Star key={i} size={20} fill="#c59b00" color="#c59b00" />
          ))}
        </div>
        <p style={styles.testimonialText}>"{testimonial.text}"</p>
      </div>
    );
  };

  const FeatureCard = ({ feature }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [inView, setInView] = useState(false);
    const ref = React.useRef(null);

    useEffect(() => {
      const node = ref.current;
      if (!node) return;
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setInView(true);
              obs.unobserve(node);
            }
          });
        },
        { threshold: 0.2 }
      );
      obs.observe(node);
      return () => obs.disconnect();
    }, [ref]);

    return (
      <div
        ref={ref}
        style={{
          ...styles.featureCard,
          background: isHovered ? '#ffffff' : '#f8f9fa',
          transition: 'transform 0.45s cubic-bezier(.2,.9,.2,1), opacity 0.6s ease',
          opacity: inView ? 1 : 0,
          transform: inView ? (isHovered ? 'translateY(-6px)' : 'translateY(0)') : 'translateY(20px)'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          style={{
            ...styles.featureIcon,
            transform: isHovered ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0deg)',
          }}
        >
          <feature.icon size={40} color="#000000" />
        </div>
        <h3 style={styles.featureTitle}>{feature.title}</h3>
        <p style={styles.featureDescription}>{feature.description}</p>
      </div>
    );
  };

  const CTAButton = ({ children, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <button
        style={{
          ...styles.ctaButton,
          transform: isHovered ? 'translateY(-3px) scale(1.05)' : 'translateY(0) scale(1)',
          boxShadow: isHovered
            ? '0 12px 35px rgba(197, 155, 0, 0.55)'
            : '0 8px 25px rgba(197, 155, 0, 0.35)',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        {children}
        <ArrowRight size={20} />
      </button>
    );
  };

  return (
    <div id="accueil" style={styles.container}>
      {/* Hero Section */}
      <section style={styles.hero}>
        {slides.map((slide, index) => (
          <div
            key={index}
            style={{
              ...styles.slide,
              opacity: currentSlide === index ? 1 : 0,
              zIndex: currentSlide === index ? 1 : 0,
            }}
          >
            <img src={slide.image} alt={slide.title} style={styles.slideImage} />
            <div style={styles.overlay}>
              <div style={styles.heroContent}>
                <h1 style={styles.heroTitle}>{slide.title}</h1>
                <p style={styles.heroSubtitle}>{slide.subtitle}</p>
                <CTAButton>{slide.cta}</CTAButton>
              </div>
            </div>
          </div>
        ))}
        <div style={styles.indicators}>
          {slides.map((_, index) => (
            <div
              key={index}
              style={{
                ...styles.indicator,
                background: currentSlide === index ? '#c59b00' : 'transparent',
              }}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* Features Section */}
      <section style={styles.section}>
        <div style={styles.featuresGrid}>
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section style={styles.darkSection}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 style={{ ...styles.sectionTitle, color: '#ffffff' }}>
            Nos Chiffres Parlent d'Eux-Mêmes
          </h2>
          <p style={{ ...styles.sectionSubtitle, color: '#cccccc' }}>
            Des milliers de clients nous font confiance chaque jour
          </p>
          <div style={styles.statsGrid}>
            {stats.map((stat, index) => (
              <StatCard key={index} {...stat} />
            ))}
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section style={{ ...styles.section, background: '#f8f9fa' }}>
        <h2 style={styles.sectionTitle}>Découvrez Nos Produits en Vidéo</h2>
        <p style={styles.sectionSubtitle}>
          Visionnez nos déballages et tests de qualité pour vous faire une idée
        </p>
        <div style={styles.videosGrid}>
          {videos.map((video, index) => (
            <VideoCard key={index} video={video} />
          ))}
        </div>
      </section>

      {/* Testimonials Section */}
      <section style={styles.section}>
        <h2 style={styles.sectionTitle}>Ce Que Disent Nos Clients</h2>
        <p style={styles.sectionSubtitle}>
          Des témoignages authentiques de professionnels satisfaits
        </p>
        <div style={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} testimonial={testimonial} />
          ))}
        </div>
      </section>

      {/* CTA Final Section */}
      <section style={styles.darkSection}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ ...styles.sectionTitle, color: '#ffffff', marginBottom: '1.5rem' }}>
            Prêt à Économiser sur Vos Achats ?
          </h2>
          <p style={{ ...styles.sectionSubtitle, color: '#cccccc', fontSize: isMobile ? '1.1rem' : '1.3rem', marginBottom: '2.5rem' }}>
            Rejoignez des milliers de clients satisfaits et profitez de nos offres exceptionnelles dès aujourd'hui
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <CTAButton>Voir le Catalogue</CTAButton>
            <button
              style={{
                ...styles.ctaButton,
                background: 'transparent',
                border: '2px solid #c59b00',
                color: '#ffffff',
              }}
            >
              Nous Contacter
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </section>
      {/* Modal player overlay */}
      <ModalPlayer />
    </div>
  );
};

export default Home;